import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { get_exports } from "./get/index.js";
import { post_exports } from "./post/index.js";
import { put_exports } from "./put.js";
//#region src/central/v3/schedules/index.ts
var schedules_exports = /* @__PURE__ */ __exportAll({
	Get: () => get_exports,
	Post: () => post_exports,
	Put: () => put_exports
});
//#endregion
export { schedules_exports };

//# sourceMappingURL=index.js.map